module.exports = __webpack_public_path__ + "assets/img/back-1.28ece7bd.png";